import { render, staticRenderFns } from "./script_list.vue?vue&type=template&id=96a0f090&scoped=true"
import script from "./script_list.vue?vue&type=script&lang=js"
export * from "./script_list.vue?vue&type=script&lang=js"
import style0 from "./script_list.vue?vue&type=style&index=0&id=96a0f090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a0f090",
  null
  
)

export default component.exports